import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip,
  ResponsiveContainer, CartesianGrid,
} from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-zip-border rounded-lg px-3 py-2 text-xs font-mono shadow-lg">
      <div className="text-zip-muted mb-1">{label}</div>
      {payload.map((p) => (
        <div key={p.dataKey} className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full inline-block" style={{ background: p.fill || p.stroke }} />
          <span className="text-zip-muted capitalize">{p.name}:</span>
          <span className="text-zip-text font-semibold">{p.value}</span>
        </div>
      ))}
    </div>
  );
};

const ActivityBarChart = ({ data }) => {
  if (!data?.length) {
    return (
      <div className="h-44 flex items-center justify-center text-zip-muted text-sm">
        No trend data available
      </div>
    );
  }

  const tickStyle = { fontSize: 11, fill: '#64748B', fontFamily: 'JetBrains Mono, monospace' };

  return (
    <ResponsiveContainer width="100%" height={180}>
      <BarChart data={data} barGap={4} barCategoryGap="30%">
        <CartesianGrid vertical={false} stroke="#E2E8F0" strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          tick={tickStyle}
          tickFormatter={(v) => v?.slice(5) ?? v}
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          tick={tickStyle}
          axisLine={false}
          tickLine={false}
          width={28}
        />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(255,255,255,0.03)' }} />
        <Bar dataKey="inward" name="Inward" fill="#E8192C" radius={[3, 3, 0, 0]} maxBarSize={24} />
        <Bar dataKey="outward" name="Outward" fill="transparent" stroke="#CBD5E1" strokeWidth={1.5} radius={[3, 3, 0, 0]} maxBarSize={24} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ActivityBarChart;
